const HorizontalFieldStyle = {
  // display: "inline",
  float: "left",
  marginRight: "40px"
};
export default HorizontalFieldStyle;
